module.exports = {
  headline: 'FAQ',
  index: ['Open positions',],
  list: [

    {
      // heading: "For sellers & brands",
      expandables: [  
        {
          header: 'Sr. Frontend Developer, Luleå, Sweden',
          content: `
          <p>
          As a Senior Frontend Developer at Spotin we want you to have more than 5 years of relevant experience. In this dynamic role and you will take the lead on a variety of engaging frontend tasks, while collaborating with our remarkable team of skilled developers. 
          </p><p>
          You will work closely with other frontend developers as well as our CTO. In this role you will have a crucial part in strengthening the framework of our growing development team and projects. At Spotin, you will not only enhance your career but also be an instrumental part of our expansion journey.
          </p><p>
          With Spotin you will be a part of a successful and experienced team that thrive with taking responsibility of their own work. You will be able to work with an exceptionally talented team of developers, and together, make the highest quality softwares in the realm of commerce.
          </p><p>
          With our organization experiencing rapid expansion both within Sweden and internationally in the forthcoming years, we're relying on you to spearhead a multitude of frontend tasks. Your technical guidance will be invaluable in aiding our  team to navigate this period of significant growth.
          </p><p>
          A successful candidate will contribute to ongoing coding related tasks/features and may also contribute to scaling and managing Spotin's frontend team.
          `
        },
        // {
        //   header: 'Product Owner, Luleå or Stockholm, Sweden',
        //   content: 'More information coming soon...'
        // },
      ]
    },
  ]
};



// WEBPACK FOOTER //
// ./pages/content/career_EN.js